export default "__VITE_ASSET__BV3oUxeu__"